import { getArrayCopy } from "../raphael.lib";
export default (function (a) {
  function b(a, g) {
    var h,
        k = d,
        m = getArrayCopy(arguments),
        n = Array.prototype.slice.call(m, 2),
        o = b.listeners(a),
        p = 0,
        q = [],
        r = {},
        s = [],
        t = c;
    s.firstDefined = f, s.lastDefined = j, c = a, d = 0;

    for (var u = 0, v = o.length; u < v; u++) {
      "zIndex" in o[u] && (q.push(o[u].zIndex), 0 > o[u].zIndex && (r[o[u].zIndex] = o[u]));
    }

    for (q.sort(e); 0 > q[p];) {
      if (h = r[q[p++]], s.push(h.apply(g, n)), d) return d = k, s;
    }

    for (u = 0; u < v; u++) {
      if (h = o[u], "zIndex" in h) {
        if (h.zIndex == q[p]) {
          if (s.push(h.apply(g, n)), d) break;

          do {
            if (p++, h = r[q[p]], h && s.push(h.apply(g, n)), d) break;
          } while (h);
        } else r[h.zIndex] = h;
      } else if (s.push(h.apply(g, n)), d) break;
    }

    return d = k, c = t, s;
  }

  var c,
      d,
      g = /[\.\/]/,
      h = /\s*,\s*/,
      e = function e(c, a) {
    return c - a;
  },
      l = {
    n: {}
  },
      f = function f() {
    for (var a = 0, b = this.length; a < b; a++) {
      if ("undefined" != typeof this[a]) return this[a];
    }
  },
      j = function j() {
    for (var a = this.length; --a;) {
      if ("undefined" != typeof this[a]) return this[a];
    }
  },
      i = Object.prototype.toString,
      k = String,
      m = Array.isArray || function (a) {
    return a instanceof Array || "[object Array]" == i.call(a);
  };

  return b._events = l, b.listeners = function (a) {
    var b,
        c,
        d,
        f,
        h,
        n,
        o,
        p,
        q = m(a) ? a : a.split(g),
        r = l,
        s = [r],
        t = [];

    for (f = 0, h = q.length; f < h; f++) {
      for (p = [], n = 0, o = s.length; n < o; n++) {
        for (r = s[n].n, c = [r[q[f]], r["*"]], d = 2; d--;) {
          b = c[d], b && (p.push(b), t = t.concat(b.f || []));
        }
      }

      s = p;
    }

    return t;
  }, b.separator = function (a) {
    a ? (a = k(a).replace(/(?=[\.\^\]\[\-])/g, "\\"), a = "[" + a + "]", g = new RegExp(a)) : g = /[\.\/]/;
  }, b.on = function (a, b) {
    if ("function" != typeof b) return function () {};

    for (var c = m(a) ? m(a[0]) ? a : [a] : k(a).split(h), d = 0, e = c.length; d < e; d++) {
      (function (a) {
        for (var c, d = m(a) ? a : k(a).split(g), f = l, h = 0, j = d.length; h < j; h++) {
          f = f.n, f = f.hasOwnProperty(d[h]) && f[d[h]] || (f[d[h]] = {
            n: {}
          });
        }

        for (f.f = f.f || [], h = 0, j = f.f.length; h < j; h++) {
          if (f.f[h] == b) {
            c = !0;
            break;
          }
        }

        c || f.f.push(b);
      })(c[d]);
    }

    return function (a) {
      +a == +a && (b.zIndex = +a);
    };
  }, b.f = function (a) {
    var c = getArrayCopy(arguments),
        d = [].slice.call(c, 1);
    return function () {
      b.apply(null, [a, null].concat(d).concat([].slice.call(c, 0)));
    };
  }, b.stop = function () {
    d = 1;
  }, b.nt = function (a) {
    var b = m(c) ? c.join(".") : c;
    return a ? new RegExp("(?:\\.|\\/|^)" + a + "(?:\\.|\\/|$)").test(b) : b;
  }, b.nts = function () {
    return m(c) ? c : c.split(g);
  }, b.off = b.unbind = function (a, c) {
    if (!a) return void (b._events = l = {
      n: {}
    });
    var d = m(a) ? m(a[0]) ? a : [a] : k(a).split(h);

    if (1 < d.length) {
      for (var f = 0, n = d.length; f < n; f++) {
        b.off(d[f], c);
      }

      return;
    }

    d = m(a) ? a : k(a).split(g);
    var o,
        p,
        q,
        f,
        n,
        r,
        s,
        t = [l],
        u = [];

    for (f = 0, n = d.length; f < n; f++) {
      for (r = 0; r < t.length; r += q.length - 2) {
        if (q = [r, 1], o = t[r].n, "*" != d[f]) o[d[f]] && (q.push(o[d[f]]), u.unshift({
          n: o,
          name: d[f]
        }));else for (p in o) {
          o.hasOwnProperty(p) && (q.push(o[p]), u.unshift({
            n: o,
            name: p
          }));
        }
        t.splice.apply(t, q);
      }
    }

    for (f = 0, n = t.length; f < n; f++) {
      for (o = t[f]; o.n;) {
        if (c) {
          if (o.f) {
            for (r = 0, s = o.f.length; r < s; r++) {
              if (o.f[r] == c) {
                o.f.splice(r, 1);
                break;
              }
            }

            o.f.length || delete o.f;
          }

          for (p in o.n) {
            if (o.n.hasOwnProperty(p) && o.n[p].f) {
              var v = o.n[p].f;

              for (r = 0, s = v.length; r < s; r++) {
                if (v[r] == c) {
                  v.splice(r, 1);
                  break;
                }
              }

              v.length || delete o.n[p].f;
            }
          }
        } else for (p in delete o.f, o.n) {
          o.n.hasOwnProperty(p) && o.n[p].f && delete o.n[p].f;
        }

        o = o.n;
      }
    }

    prune: for (f = 0, n = u.length; f < n; f++) {
      for (p in o = u[f], o.n[o.name].f) {
        continue prune;
      }

      for (p in o.n[o.name].n) {
        continue prune;
      }

      delete o.n[o.name];
    }
  }, b.once = function (a, c) {
    var d = function d() {
      return b.off(a, d), c.apply(this, arguments);
    };

    return b.on(a, d);
  }, b.version = "0.5.3", b.toString = function () {
    return "You are running Eve 0.5.3";
  }, a.eve = b, b;
})("undefined" == typeof window ? "undefined" == typeof global ? null : global : window);